export default __webpack_public_path__ + "static/media/star_logo.2892e320.png";